<div class="subtask-section-wrapper" *ngIf="!isCreateMode">

  <!-- Header: count + info icon + Add button -->
  <div class="subtask-list-header">
    <div class="subtask-list-header-left">
      <app-task-progress-indicator [subtasks]="subtasks" [showBar]="false"></app-task-progress-indicator>
      <span class="subtask-count" *ngIf="!subtasks.length">Child Cases</span>
      <mat-icon *ngIf="hasIncompleteSubtasks" class="subtask-info-icon"
        matTooltip="All subtasks must be completed or cancelled before the parent task can be marked as done or cancelled.">
        info_outline
      </mat-icon>
    </div>
    <button *ngIf="!isCreateMode" class="scraii-secondary-btn subtask-add-btn" type="button" (click)="addSubtask()">
      + Add Child Case
    </button>
  </div>

  <!-- Accordion -->
  <mat-accordion multi *ngIf="subtasks.length">
    <app-subtask-item *ngFor="let st of subtasks; let i = index; trackBy: trackBySubtaskId" [subtask]="st" [index]="i"
      [initiallyExpanded]="!st.name"
      [isViewMode]="isViewMode && editingSubtaskId !== st.subtask_id"
      [isEditMode]="isEditMode || editingSubtaskId === st.subtask_id"
      [isCreateMode]="isCreateMode"
      [currentUserName]="currentUserName" (subtaskChange)="onSubtaskChange($event, i)"
      (removeSubtask)="onRemoveSubtask($event)" (commentAdded)="onCommentAdded($event)"
      (editRequested)="onEditSubtaskRequested(st.subtask_id)">
    </app-subtask-item>
  </mat-accordion>

  <!-- Empty state (view mode only) -->
  <div class="subtask-empty" *ngIf="!subtasks.length && isViewMode">No Child Cases.</div>

</div>